import React from 'react';
import { ComplianceActionsList } from 'components/RunPayroll/ComplianceActions/ComplianceActionsList/ComplianceActionsList';
import { ComplianceActionsContextProvider } from 'components/RunPayroll/ComplianceActions/contexts/ComplianceActionsContext';
import { useIsPayPtEnabled } from './hooks/useIsPayPtEnabled';

export const ComplianceActions = () => {
  const isPayPtOnRunPayrollEnabled = useIsPayPtEnabled();

  if (!isPayPtOnRunPayrollEnabled) {
    return null;
  }

  return (
    <ComplianceActionsContextProvider>
      <ComplianceActionsList />
    </ComplianceActionsContextProvider>
  );
};
